// eslint-disable-next-line import/no-extraneous-dependencies
import styled from 'styled-components';
export const OptionCardContainer = styled.div `
  & + & {
    margin-top: var(--spacing-size-4xs);
  }

  label {
    display: flex;
    align-items: center;
    gap: var(--spacing-size-3xs);
    padding: var(--spacing-size-4xs) var(--spacing-inset-size-sm);
    /* Um pouco mais alto quando tem só uma linha, como no drawer de idioma. */
    box-sizing: border-box;
    min-height: 52px;
    cursor: pointer;
    /* A linha cinza clara mostra que a opção é selecionável. */
    border: 1px solid var(--color-neutral-200);
    border-radius: var(--border-radius-md);
    /* Clara sobre o painel cinza do drawer: é o que mostra que dá para clicar. */
    background-color: var(--color-neutral-100);
    transition-duration: var(--velocity-medium);
    transition-property: background-color, border-color;
    transition-timing-function: cubic-bezier(var(--vibe-soft));
  }

  /* O input existe para acessibilidade; o cartão inteiro é a área clicável. */
  input[type='radio'] {
    position: absolute;
    width: 1px;
    height: 1px;
    margin: 0;
    opacity: 0;
    pointer-events: none;
  }

  label:hover {
    background-color: var(--color-neutral-background);
  }

  /* Só no teclado: o clique do mouse não deixa contorno de foco. */
  label:has(input:focus-visible) {
    outline: 2px solid var(--color-contrast-focused);
    outline-offset: 2px;
  }

  &.checked label {
    /*
     * 2px na escolhida. O padding perde 1px para a altura do cartão não mudar
     * quando a seleção troca.
     */
    border: 2px solid var(--color-action-default);
    padding: calc(var(--spacing-size-4xs) - 1px)
      calc(var(--spacing-inset-size-sm) - 1px);
    background-color: var(--color-contrast-white);
  }

  /* Maior que no menu: equilibra com as duas linhas de texto do cartão. */
  .root-app_flag {
    width: 2rem;
  }

  .option-card_text {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    min-width: 0;
    gap: var(--spacing-size-4xs);
  }

  /* O nome da opção é sempre negrito, escolhida ou não. */
  .option-card_title {
    font-size: var(--font-size-default);
    font-weight: var(--font-weight-semibold);
    color: var(--color-neutral-600);
  }

  /*
   * Linha de apoio: menor, sem negrito e em minúsculas (só a primeira letra
   * maiúscula), para não competir com o título.
   */
  .option-card_description {
    display: block;
    font-size: 11px;
    line-height: 16px;
    color: grey;
    text-transform: lowercase;

    strong {
      font-weight: var(--font-weight-regular, normal);
    }
  }

  /*
   * O global \"#root-app_side_content *\" (global.style.ts) pinta tudo de
   * neutral-500 e, por ter id, vence as regras de classe. Repetir o id aqui é
   * o que deixa a linha técnica mais clara que o título.
   */
  #root-app_side_content & .option-card_description,
  #root-app_side_content & .option-card_description * {
    color: grey !important;
  }

  .option-card_check {
    display: flex;
    flex-shrink: 0;
    align-items: center;

    path {
      fill: var(--color-brand-500);
    }
  }
`;
//# sourceMappingURL=style.js.map